import styled from 'styled-components';

import POISearcher from './POISearcher';

export default styled(POISearcher)`
  .header {
    padding: 16px;
    background: var(--grey700);
  }

  .row {
    display: flex;
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .field {
    flex: 1;
    margin-right: 8px;
    height: 32px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
